import ProviderBox from './ProviderBox';
import StyledProviderBoxesView from './ProviderBoxesView.style';

interface ProviderBoxesViewProps {
  providers: Record<string, unknown>;
  onProviderClick: (provider: unknown) => void;
  disabled: boolean;
  lastLoggedInProviderName: string;
}

export function ProviderBoxesView({
  providers = {},
  onProviderClick,
  disabled,
  lastLoggedInProviderName,
}: ProviderBoxesViewProps) {
  return (
    <StyledProviderBoxesView providers={providers}>
      {Object.keys(providers).map(providerKey => (
        <ProviderBox
          key={providerKey}
          providers={providers}
          providerKey={providerKey}
          disabled={disabled}
          onProviderClick={onProviderClick}
          lastLoggedInProviderName={lastLoggedInProviderName}
        />
      ))}
    </StyledProviderBoxesView>
  );
}
